// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import { VehicleDeviceManagementAreaRoutes } from '@backoffice-frontend/common'
import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { UsbPlugIcon } from '@moia-dev/pace-icons'

// TODO: add your NavigationItem to the main menu
// check docs/how-tos/add-a-new-library.md for more info

// TODO: Replace icon with your actual area icon
export const VehicleDeviceManagementAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={VehicleDeviceManagementAreaRoutes.route}
      Icon={UsbPlugIcon}
    />
  )
}
